import { Theme } from '@mui/material';

export const useAIRenderStyles = () => ({
  iconTray: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  trayButton: {
    cursor: 'pointer',
    borderRadius: '.25rem',
    padding: '.25rem',
    marginRight: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    color: '#888',
    '&:hover': {
      backgroundColor: '#f3f3f3',
    },
  },
  grid: {},
});
